import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import Clarity from '@microsoft/clarity';
let appInsights = null;
let initialized = false;
let cloudRoleName = 'unknown-web';
/**
 * 브라우저에서 Application Insights와 Clarity를 한 번만 초기화한다.
 * `enabled`가 false이거나 이미 초기화됐으면 재호출해도 부수효과가 없다.
 */
export function initTelemetry(options) {
    if (initialized || !options.enabled) {
        return;
    }
    cloudRoleName = options.cloudRoleName;
    if (options.connectionString) {
        appInsights = new ApplicationInsights({
            config: {
                connectionString: options.connectionString,
                enableAutoRouteTracking: false,
                enableCorsCorrelation: true,
                enableRequestHeaderTracking: true,
                enableResponseHeaderTracking: true,
            },
        });
        appInsights.addTelemetryInitializer((envelope) => {
            envelope.tags = envelope.tags ?? {};
            envelope.tags['ai.cloud.role'] = cloudRoleName;
        });
        appInsights.loadAppInsights();
    }
    if (options.clarityProjectId) {
        Clarity.init(options.clarityProjectId);
        Clarity.setTag('cloudRoleName', cloudRoleName);
    }
    initialized = true;
}
/** 초기화 이후에만 Application Insights에 페이지뷰를 기록한다. */
export function trackPageView(name) {
    if (!initialized) {
        return;
    }
    appInsights?.trackPageView({ name });
}
/**
 * 커스텀 이벤트를 Application Insights에 기록한다.
 * 문자열 속성은 Clarity 태그로도 동기화한다.
 */
export function trackEvent(name, properties) {
    if (!initialized) {
        return;
    }
    appInsights?.trackEvent({ name }, properties);
    if (properties) {
        for (const [key, value] of Object.entries(properties)) {
            if (typeof value === 'string') {
                Clarity.setTag(key, value);
            }
        }
    }
}
/** 로그인 사용자 id를 Application Insights·Clarity 세션에 연결한다. */
export function setAuthenticatedUser(userId) {
    if (!initialized) {
        return;
    }
    appInsights?.setAuthenticatedUserContext(userId);
    Clarity.identify(userId);
}
/** Application Insights의 인증 사용자 컨텍스트를 해제한다. */
export function clearAuthenticatedUser() {
    if (!initialized) {
        return;
    }
    appInsights?.clearAuthenticatedUserContext();
}
//# sourceMappingURL=telemetry.js.map